import React from 'react';
import { instanceOf, func } from 'prop-types';
import moment from 'moment';
import { numberWithCommas } from '../../../../util/CommonUtils';
import MuiLightTooltip from '../../shared/MuiLightTooltip';
import ContextMenu from './ContextMenu';

const CTTableRowItems = ({ data = null, onRowSelect, handleAction }) => {
  const { name, sample, weighted, pct, updts, isActive, study } = data;
  
  const handleRowClick = (event, activeFlag) => {
    if (event) {
      event.stopPropagation();
    }
    onRowSelect(activeFlag, data || null)
  }
  return (
    <div
      className={`de--table__row ${isActive ? 'de--table__row--active' : ' '}`}
      onClick={(event) => handleRowClick(event, !isActive)}
    >
      {/* <div className="de--table__col ct--col__select">
        <DECheckbox
          onChange={onRowSelect}
          id={`ct_select_${data.id}`}
          isChecked={isActive}
          data={data}
        />
      </div> */}

      <div className="de--table__col ct--col__ct">
        <div className="de--table__col--root">
          <button
            className="ct--col__ct--btn"
            id="targetBtn"
            title={name}
            onClick={() => {}}
            type="button"
          >
            <span>{name}</span>
          </button>
          <button
            className="ct--col__ct--btn"
            id="studyLabelBtn"
            title={study}
            onClick={() => {}}
            type="button"
          >
            <small>{study}</small>
          </button>
        </div>
      </div>

      <div className="de--table__col ct--col__sample">
        <div className="de--table__col--root">
          <div>
            <MuiLightTooltip
              arrow
              title="Represents the surveyed number of U.S. adults (18+) for the criteria defined in the target."
            >
              <span>{numberWithCommas(sample)}</span>
            </MuiLightTooltip>
          </div>
        </div>
      </div>

      <div className="de--table__col ct--col__wgth">
        <div className="de--table__col--root">
          <div>
            <MuiLightTooltip
              arrow
              title={`Represents the projected number of U.S. adults (18+) for the criteria defined in the target. 
                It is reflective of the audience size prior to modeling into a census-level dataset.`}
            >
              <span>{numberWithCommas(weighted.toFixed(0))}</span>
            </MuiLightTooltip>
          </div>
        </div>
      </div>

      <div className="de--table__col ct--col__per">
        <div className="de--table__col--root">
          <div>
            <MuiLightTooltip
              arrow
              title={`The percent of the total U.S. adult (18+) universe that is represented by the criteria defined 
              in the target. It is reflective of the audience percent prior to modeling into a census-level dataset.`}
            >
              <span>{pct.toFixed(2)}%</span>
            </MuiLightTooltip>
          </div>
        </div>
      </div>

      <div className="de--table__col ct--col__lmodified">
        <div className="de--table__col--root">
          <span>{moment(updts).format('MM/DD/YY hh:mm:ss')}</span>
        </div>
      </div>
      <div className="de--table__col ct--col__actions">
        <div className="de--table__col--root ">
          <ContextMenu row={data} onClick={handleAction} handleRowClick={handleRowClick}/>
        </div>
      </div>
    </div>
  );
};

CTTableRowItems.propTypes = {
  data: instanceOf(Object).isRequired,
  onRowSelect: func,
  handleAction: func,
};

export default CTTableRowItems;
